import { ContactLeadPayload, ContactProvider, ContactSubmissionResult } from './types';

export class DemoContactProvider implements ContactProvider {
  name = 'DemoLocalProvider';

  async submitLead(payload: ContactLeadPayload): Promise<ContactSubmissionResult> {
    // Artificial safe delay to mimic network submission
    await new Promise((resolve) => setTimeout(resolve, 800));

    if (!payload.name || !payload.phone) {
      return {
        success: false,
        error: 'Name and phone are required fields.',
      };
    }

    // Safely store in local demo log without external leaks
    try {
      const existing = JSON.parse(localStorage.getItem('sdp_demo_leads') || '[]');
      existing.push(payload);
      localStorage.setItem('sdp_demo_leads', JSON.stringify(existing));
    } catch {
      // ignore
    }

    return {
      success: true,
      messageId: `lead-${Date.now()}`,
    };
  }
}

